import Menu from './menu'
import MenuItem from './MenuItem'
import SubMenu from './SubMenu'
Menu.SubMenu = SubMenu;
Menu.MenuItem = MenuItem;
export default Menu;
